import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { Mobile, Desktop } from 'Shared/components/Responsive'
import arrowLeftIcon from 'Shared/icons/arrow-left.svg'

import { ModalProps } from './props'
import {
  ModalContainer,
  MobileModalContainer,
  HeaderContainer,
  HeaderTitle,
  BackButton,
} from './styles'

export const Modal: FunctionComponent<ModalProps> = ({
  title,
  isModalVisible,
  modalHeaderGreen,
  closeModal,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Desktop>
        <ModalContainer
          title={title}
          visible={isModalVisible}
          // @ts-ignore
          modalHeaderGreen={modalHeaderGreen}
          onCancel={closeModal}
        >
          {children}
        </ModalContainer>
      </Desktop>
      <Mobile>
        <HeaderContainer>
          <BackButton src={arrowLeftIcon} onClick={closeModal} />
          <HeaderTitle>{title}</HeaderTitle>
        </HeaderContainer>
        <MobileModalContainer>{children}</MobileModalContainer>
      </Mobile>
    </>
  )
}
